module.exports = __webpack_public_path__ + "img/3f_l_sapporo.5feae0b9.jpg";